import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface RoofProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Roof: React.FC<RoofProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [roof, setRoof] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Exterior Features']?.['Roof'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Exterior Features': { ...s.values?.['Exterior Features'], Roof: v } } })
    );
    const label = 'Roof';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={roof}
                />
            ) : (
                <TextBox
                    value={roof ?? ''}
                    onChange={(value) => setRoof(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
